import { render, staticRenderFns } from "./EmployeeScanHistoryModal.vue?vue&type=template&id=881796a6&scoped=true&style=top%3A%2020px"
import script from "./EmployeeScanHistoryModal.vue?vue&type=script&lang=ts"
export * from "./EmployeeScanHistoryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881796a6",
  null
  
)

export default component.exports